import { ActionIcon } from "@mantine/core";
import { LayoutGrid, List } from "lucide-react";

type ViewMode = "list" | "card";

type ViewModeToggleProps = {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
};

const ViewModeToggle = ({ value, onChange }: ViewModeToggleProps) => (
  <ActionIcon.Group>
    <ActionIcon
      variant={value === "list" ? "filled" : "default"}
      color={value === "list" ? "main" : "gray"}
      size="sm"
      onClick={() => onChange("list")}
      aria-label="List view"
    >
      <List size={14} />
    </ActionIcon>
    <ActionIcon
      variant={value === "card" ? "filled" : "default"}
      color={value === "card" ? "main" : "gray"}
      size="sm"
      onClick={() => onChange("card")}
      aria-label="Card view"
    >
      <LayoutGrid size={14} />
    </ActionIcon>
  </ActionIcon.Group>
);

export default ViewModeToggle;
